import React, { useState } from 'react';
import { Avatar } from './Avatar';
import { ACTIVITY, USERS } from './data';
import { ActivityItem } from './types';
interface ActivityTabProps {
  currentUser: string;
}
export function ActivityTab({
  currentUser
}: ActivityTabProps) {
  const [text, setText] = useState('');
  const [extraComments, setExtraComments] = useState<ActivityItem[]>([]);
  const allActivity = [...ACTIVITY, ...extraComments];
  const send = () => {
    if (!text.trim()) return;
    setExtraComments(prev => [...prev, {
      user: currentUser,
      action: text.trim(),
      time: 'Just now'
    }]);
    setText('');
  };
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }} data-id="element-1">
      <div style={{
      flex: 1,
      overflowY: 'auto',
      padding: '16px 20px'
    }} data-id="element-2">
        <div style={{
        position: 'relative',
        paddingLeft: 18
      }} data-id="element-3">
          <div style={{
          position: 'absolute',
          left: 7,
          top: 4,
          bottom: 4,
          width: 1.5,
          background: '#E6E4DF'
        }} data-id="element-4" />
          {allActivity.map((a, i) => {
          const u = a.user ? USERS[a.user] : null;
          return <div key={i} style={{
            display: 'flex',
            gap: 10,
            marginBottom: 14,
            position: 'relative'
          }} data-id="element-5">
                <div style={{
              position: 'absolute',
              left: -18,
              top: 3,
              width: 9,
              height: 9,
              borderRadius: '50%',
              background: u?.color || '#2D7A6E',
              border: '2px solid white',
              boxShadow: '0 0 0 1px #E6E4DF',
              zIndex: 2
            }} data-id="element-6" />
                <div data-id="element-7">
                  <div style={{
                fontSize: 12.5,
                color: '#1C2530',
                lineHeight: 1.5
              }} data-id="element-8">
                    {u ? <span style={{
                  fontWeight: 700
                }} data-id="element-9">
                        {u.name}
                      </span> : <span style={{
                  fontWeight: 700,
                  color: '#2D7A6E'
                }} data-id="element-10">
                        Luthor
                      </span>}{' '}
                    {a.action}
                  </div>
                  <div style={{
                fontSize: 10,
                color: '#94A3B8',
                marginTop: 1
              }} data-id="element-11">
                    {a.time}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* General comment input */}
      <div style={{
      padding: '12px 20px',
      borderTop: '1px solid #E6E4DF',
      background: '#FAFAF8'
    }} data-id="element-12">
        <div style={{
        display: 'flex',
        gap: 8,
        alignItems: 'flex-start'
      }} data-id="element-13">
          <Avatar uid={currentUser} size={24} data-id="element-14" />
          <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 6
        }} data-id="element-15">
            <textarea value={text} onChange={e => setText(e.target.value)} onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              send();
            }
          }} placeholder="Add a comment for the team…" rows={2} style={{
            width: '100%',
            padding: '8px 10px',
            border: '1px solid #E2E8F0',
            borderRadius: 6,
            fontSize: 12,
            fontFamily: 'inherit',
            outline: 'none',
            resize: 'none',
            lineHeight: 1.5,
            color: '#1C2530'
          }} data-id="element-16" />
            <div style={{
            display: 'flex',
            justifyContent: 'flex-end'
          }} data-id="element-17">
              <button onClick={send} style={{
              padding: '5px 12px',
              borderRadius: 5,
              border: 'none',
              background: text.trim() ? '#2D7A6E' : '#E2E8F0',
              color: text.trim() ? 'white' : '#94A3B8',
              fontSize: 11,
              fontWeight: 700,
              cursor: text.trim() ? 'pointer' : 'default',
              fontFamily: 'inherit'
            }} data-id="element-18">
                Comment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}